import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AdministradoresApi } from '@/services/api-routes'
import type { AtualizarAdministradorPayload, CriarAdministradorPayload } from '@/types/administrador'
import { administradoresKeys } from '@/http/queryKeys'
import { notifyErrorFor, notifySuccess } from '@/utility/notify'

export const useCriarAdministradorMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: CriarAdministradorPayload) => AdministradoresApi.criar(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: administradoresKeys.all })
      notifySuccess('Administrador criado com sucesso!')
      onSuccess?.()
    },
    onError: (error) => notifyErrorFor('criar o administrador', error),
  })
}

export const useAtualizarAdministradorMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: AtualizarAdministradorPayload) => AdministradoresApi.atualizar(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: administradoresKeys.all })
      notifySuccess('Administrador atualizado com sucesso!')
      onSuccess?.()
    },
    onError: (error) => notifyErrorFor('atualizar o administrador', error),
  })
}

export const useAtualizarSituacaoAdministradorMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ administradorId, ativar }: { administradorId: string; ativar: boolean }) =>
      ativar ? AdministradoresApi.reativar(administradorId) : AdministradoresApi.inativar(administradorId),
    onSuccess: (_data, { ativar }) => {
      void queryClient.invalidateQueries({ queryKey: administradoresKeys.all })
      notifySuccess(`Administrador ${ativar ? 'reativado' : 'inativado'} com sucesso!`)
    },
    onError: (error) => notifyErrorFor('atualizar a situação do administrador', error),
  })
}

export const useResetarSenhaAdministradorMutation = () => {
  return useMutation({
    mutationFn: (administradorId: string) => AdministradoresApi.resetarSenha(administradorId),
    onSuccess: () => {
      notifySuccess('Senha do administrador redefinida para a senha padrão!')
    },
    onError: (error) => notifyErrorFor('redefinir a senha do administrador', error),
  })
}
